import { useState, useEffect, useCallback } from "react";
import axios from "axios";

/**
 * Custom hook for fetching form overview by form code.
 * Follows the project's established architecture pattern.
 */
export function useFormOverview(formCode) {
  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchOverview = useCallback(async () => {
    console.log("useFormOverview - fetchOverview called with formCode:", formCode);
    if (!formCode) {
      console.log("useFormOverview - No formCode provided, skipping fetch");
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const url = `/v1/employee/forms/${formCode}`;
      console.log("useFormOverview - Fetching from:", url);
      const response = await axios.get(url);
      console.log("useFormOverview - Response:", response.data);
      setOverview(response.data);
    } catch (err) {
      console.error("useFormOverview - Error loading form overview:", err);
      setError("Failed to load form overview");
    } finally {
      setLoading(false);
    }
  }, [formCode]);

  useEffect(() => {
    fetchOverview();
  }, [fetchOverview]);

  return { overview, loading, error, refetch: fetchOverview };
}

export default useFormOverview;
